import NProgress from "nprogress";
import "../styles/nprogress.css";
import React from "react";
import { createRoot } from "react-dom/client";
import GlobalLoader from "../components/GlobalLoader";

// Configure NProgress
NProgress.configure({
  showSpinner: false,
  minimum: 0.1,
  trickleSpeed: 200,
  easing: "ease",
  speed: 500,
});

let progressCounter = 0;
let apiCallCounter = 0;
let loaderContainer: HTMLElement | null = null;
let loaderRoot: any = null;

// Function to create and manage the loader container
const getLoaderContainer = (): HTMLElement => {
  if (!loaderContainer) {
    loaderContainer = document.createElement("div");
    loaderContainer.id = "global-api-loader";
    document.body.appendChild(loaderContainer);
    loaderRoot = createRoot(loaderContainer);
  }
  return loaderContainer;
};

/**
 * Shows the global loader with a custom message
 * @param message Optional custom message to display
 */
const showGlobalLoader = (message: string = "Loading...") => {
  getLoaderContainer();
  if (loaderRoot) {
    loaderRoot.render(React.createElement(GlobalLoader, { message }));
  }
};

/**
 * Hides the global loader
 */
const hideGlobalLoader = () => {
  if (loaderRoot) {
    loaderRoot.render(null);
  }
};

/**
 * Starts the progress bar for general loading (route changes, etc.)
 * This uses NProgress bar at the top of the screen
 */
export const startLoading = () => {
  if (progressCounter === 0) {
    NProgress.start();
  }
  progressCounter++;
};

/**
 * Stops the progress bar
 */
export const stopLoading = () => {
  progressCounter--;
  if (progressCounter <= 0) {
    progressCounter = 0;
    NProgress.done();
  }
};

/**
 * Shows a full-screen loading spinner with blur effect
 * Designed specifically for API calls
 * @param message Optional custom message to display during loading
 */
export const startApiLoading = (message?: string) => {
  if (apiCallCounter === 0) {
    showGlobalLoader(message);
  }
  apiCallCounter++;
};

/**
 * Hides the full-screen loading spinner
 */
export const stopApiLoading = () => {
  apiCallCounter--;
  if (apiCallCounter <= 0) {
    apiCallCounter = 0;
    hideGlobalLoader();
  }
};
